import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const loginUser = createAsyncThunk(
  "users/login",
  async ({ username, password }, thunkAPI) => {
    console.log(process.env.REACT_APP_API_URL);
    let formData = new FormData();
    formData.append("userName", username);
    formData.append("password", password);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "login",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "*/*",
          }
          ,
        }
      );

      // Log response untuk melihat data yang diterima dari API
      console.log("Login Response:", response);

      if (response.status === 200) {
        localStorage.setItem("user", JSON.stringify(response.data.data));
        return response.data.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      // Log error untuk melihat error dari API
      console.error("Login Error:", e);
      return thunkAPI.rejectWithValue(
        e?.response?.data || { message: "Gagal login. Server tidak merespon." }
      );
    }
  }
);

export const checkLoginUser = createAsyncThunk(
  "users/checkLogin",
  async ({}, thunkAPI) => {
    try {
      console.log(process.env.REACT_APP_API_URL);

      const response = await axios.get(
        process.env.REACT_APP_API_URL + "checkLogin",
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );

      if (response.status === 202) {
        if (response.data.status === "Fail") {
          localStorage.removeItem("user");
          window.location.replace("/login");
        }
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(
        e?.response?.data || { message: "Gagal login. Server tidak merespon." }
      );
    }
  }
);

export const changePassUser = createAsyncThunk(
  "users/changePass",
  async ({ userName, password, newPassword }, thunkAPI) => {
    let formData = new FormData();
    formData.append("userName", userName);
    formData.append("password", password);
    formData.append("newPassword", newPassword);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "changePassowrd",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );

      if (response.status === 200) {
        return response.data.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(
        e?.response?.data || { message: "Gagal ganti password. Server tidak merespon." }
      );
    }
  }
);

const initialState = {
  message: "",
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: {
    [loginUser.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      // Pastikan tidak ada error yang terjadi
      state.message = "Login berhasil";
      return state;
    },
    [loginUser.rejected]: (state, { payload, error }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || error?.message || "Terjadi kesalahan login";
      return state;
    },
    [loginUser.pending]: (state) => {
      state.isFetching = true;
    },

    [changePassUser.fulfilled]: (state, { payload }) => {
      state.isChangePassFetching = false;
      state.isChangePassSuccess = true;
      state.message = "Berhasil";
      return state;
    },
    [changePassUser.rejected]: (state, { payload }) => {
      state.isChangePassFetching = false;
      state.isChangePassError = true;
      state.errorMessage = payload?.message || "Silahkan login kembali";
    },
    [changePassUser.pending]: (state) => {
      state.isChangePassFetching = true;
    },
  },
});

export const userSelector = (state) => state.user;
